/* eslint-disable react-hooks/exhaustive-deps */
import { FieldValues, UseFormGetValues, UseFormRegister, UseFormSetValue } from "react-hook-form";
import { Blank, Div, Font, Input, Label, LineBox, LineInputBox, LineInputLabel, Radio, RadioBox, Span, WrapMobile } from "../../styles/commonStyle";
import { listBorderColor, noticeRedColor } from "../../styles/theme";
import Dropdown, { Group, Option } from "react-dropdown";
import { POSTCODE_URL } from "../../constants";
import { useDaumPostcodePopup } from "react-daum-postcode";
import { useState } from "react";
import { RoundButton } from "../../view/linkAccount/style";
import { ResponseModel, RESULT } from "../../model/response";
import { APILIST, request } from "../../repository/api";
import Timer from "../timer/timer";
import { InfoText, Status } from "../../view/register/components/infoText";

function InputLine({
  label,
  name,
  placeholder,
  necessary,
  type,
  selectList,
  valueList,
  register,
  errors,
  onClick,
  noBorder,
  options,
  setValue,
  getValues,
  watch,
  labelWidth,
  onChange,
  readOnly,
  readData,
  labelColor,
  defaultValue,
  isBottomlabel,
  bottomLabel,
  tabIndex,
  disabled,
  value,
  hasPhoneNumberCertification,
  handleCertificationComplete,
  inputBgColor
}: {
  label?: string;
  name: string;
  placeholder?: string;
  necessary?: boolean;
  type: string;
  selectList?: Array<string>;
  valueList?: Array<string>;
  register?: UseFormRegister<FieldValues>;
  errors?: any;
  onClick?: () => void;
  noBorder?: boolean;
  options?: (Group | Option | string)[];
  setValue?: UseFormSetValue<FieldValues>;
  getValues?: UseFormGetValues<FieldValues>;
  watch?: any;
  labelWidth?: string;
  onChange?: any;
  readOnly?: boolean;
  readData?: string | JSX.Element;
  labelColor?: string;
  defaultValue?: string;
  isBottomlabel?: boolean;
  bottomLabel?: string;
  tabIndex?: number;
  disabled?: boolean;
  value?: any;
  hasPhoneNumberCertification?: boolean;
  handleCertificationComplete?: () => void;
  inputBgColor?: string;
}) {
  const openPostCode = useDaumPostcodePopup(POSTCODE_URL);
  const [isSendCertification, setIsSendCertification] = useState<boolean>(false);
  const [authCode, setAuthCode] = useState('');
  const [showTimer, setShowTimer] = useState<boolean>(false);
  const [timerKey, setTimerKey] = useState<number>(0);

  const postCodeHandleClick = () => {
    openPostCode({ onComplete: postCodeHandleComplete });
  };
  const postCodeHandleComplete = (data: any) => {
    setValue!(
      "rdnmadr",
      data.roadAddress
      // { shouldValidate: true }
    );
    setValue!("adres", data.jibunAddress === "" ? data.autoJibunAddress : data.jibunAddress);
    setValue!("zipCode", data.zonecode);
  };

  const handleSendAuthCode = async () => {
    const phoneNumber = watch ? watch("phone") : null;
    let res: ResponseModel<any> = await request(APILIST.CERTIFI_PHONE, "post", undefined, {
      "ty": "AUTH",
      "phone": phoneNumber
    });
    if (res.result === RESULT.OK) {
      alert("카카오톡 인증번호가 발송되었습니다.");
      setIsSendCertification(true);
      setShowTimer(true);
      setTimerKey(prev => prev + 1);
    } else {
      alert(res?.msg);
    }
  }

  const handleCheckAuthCode = async () => {
    let res: ResponseModel<any> = await request(APILIST.CERTIFI_AUTHCODE, "post", undefined, {
      "authCode": authCode,
    });
    if (res.result === RESULT.OK) {
      alert("인증이 완료되었습니다.");
      setIsSendCertification(false);
      setShowTimer(false);
      handleCertificationComplete?.();
    } else {
      alert(res?.msg);
    }
  }

  const handleTimerExpired = () => {
    alert("인증 시간이 만료되었습니다. 다시 인증번호를 발송해주세요.");
    setIsSendCertification(false);
    setShowTimer(false);
    setAuthCode('');
  }

  let labelContent = label ? (
    <LineInputLabel width={labelWidth} bgColor={labelColor} className="p-[0.5rem]">
      {label}
      {necessary ? <Span color={noticeRedColor}>*</Span> : null}
    </LineInputLabel>
  ) : null;

  return (
    <LineBox noBorder={noBorder}>
      <WrapMobile>
        {labelContent}
        <LineInputBox>
          {(() => {
            switch (type) {
              case "text":
                return (
                  <Div className="w-full flex flex-col gap-[10px]">
                    <Div className="w-full flex items-center gap-[10px]">
                      <Input
                        type={type}
                        placeholder={placeholder}
                        {...register!(name)}
                        name={name}
                        tabIndex={tabIndex}
                        isError={errors ? true : false}
                        onClick={onClick}
                        onChange={onChange ? (e) => onChange(e) : (e) => setValue!(name, e.target.value)}
                        onKeyDown={readOnly ? (e) => e.preventDefault() : undefined}
                        defaultValue={defaultValue}
                        disabled={disabled}
                        value={value}
                        style={{ backgroundColor: inputBgColor }}
                      />
                      {isBottomlabel ? (
                        <Font fontSize="0.9rem" color={listBorderColor}>
                          {bottomLabel}
                        </Font>
                      ) : null}
                      {hasPhoneNumberCertification && !disabled ? (
                        <RoundButton onClick={async (e: any) => {
                          e.preventDefault();
                          await handleSendAuthCode();
                        }}>
                          인증번호 발송
                        </RoundButton>
                      ) : null}
                    </Div>
                    {isSendCertification ? (
                      <Div className="w-full flex flex-col">
                        <Div className="w-full flex items-center gap-[10px]">
                          <Input type="text" placeholder="인증번호 6자리를 입력해주세요." onChange={(e) => setAuthCode(e.target.value)} />
                          <RoundButton onClick={async (e: any) => {
                            e.preventDefault();
                            await handleCheckAuthCode();
                          }}>
                            인증번호 확인
                          </RoundButton>
                        </Div>
                        {showTimer && (
                          <Div className="text-red-500 text-sm">
                            남은 시간: <Timer key={timerKey} mm={3} ss={0} setTimer={handleTimerExpired} />
                            <Div style={{ marginTop: "6px" }}> 
                              <InfoText status={Status.INFO} text="인증번호가 카카오톡으로 발송됩니다." label={false} />
                            </Div>
                          </Div>
                        )}
                      </Div>
                    ) : null}
                  </Div>
                );
              case "number":
                return (
                  <Div className="w-full">
                    <Input
                      type={type}
                      placeholder={placeholder}
                      {...register!(name)}
                      name={name}
                      tabIndex={tabIndex}
                      isError={errors ? true : false}
                      onClick={onClick}
                      onChange={onChange ? (e) => onChange(e) : (e) => setValue!(name, e.target.value)}
                      onKeyDown={readOnly ? (e) => e.preventDefault() : undefined}
                      defaultValue={defaultValue}
                    // key={defaultValue}
                    />
                    {isBottomlabel ? (
                      <Font fontSize="0.9rem" color={listBorderColor}>
                        {bottomLabel}
                      </Font>
                    ) : null}
                  </Div>
                );
              case "password":
                return (
                  <Div className="w-full">
                    <Input
                      type={type}
                      placeholder={placeholder}
                      {...register!(name)}
                      name={name}
                      tabIndex={tabIndex}
                      isError={errors ? true : false}
                      onClick={onClick}
                      onChange={onChange ? (e) => onChange(e) : (e) => setValue!(name, e.target.value)}
                      onKeyDown={readOnly ? (e) => e.preventDefault() : undefined}
                      autoComplete="off"
                    />
                  </Div>
                );
              case "adres":
                return (
                  <Div className="w-full">
                    <Input
                      type={type}
                      placeholder={placeholder}
                      {...register!(name)}
                      name={name}
                      tabIndex={tabIndex}
                      isError={errors ? true : false}
                      onClick={postCodeHandleClick}
                      onKeyDown={readOnly ? (e) => e.preventDefault() : undefined}
                      defaultValue={defaultValue}
                    // key={defaultValue}
                    />
                  </Div>
                );
              case "radio":
                return (
                  <RadioBox>
                    {selectList?.map((value, index) => (
                      <Div className="flex items-center max-[640px]:pb-[0.5rem]" key={label + value}>
                        <Label className="whitespace-nowrap" changeFontSize="12px">
                          <Radio id={label + value} type={type} value={valueList![index]} tabIndex={tabIndex} {...register!(name)} name={name} />
                          <Blank width="4px" />
                          {value}
                          <Blank width="16px" />
                        </Label>
                      </Div>
                    ))}
                  </RadioBox>
                );
              case "dropdown":
                return (
                  <Div className="w-full">
                    <Dropdown
                      options={options!}
                      onChange={(e) => onChange(e)}
                      value={getValues!(name) ?? "선택없음"}
                      placeholder="Select an option"
                    />
                  </Div>
                );
              case "file":
                return (
                  <Div className="w-full filebox">
                    <Input
                      className="upload-name"
                      type={type}
                      placeholder={placeholder}
                      {...register!(name)}
                      name={name}
                      isError={errors ? true : false}
                      accept=".zip"
                      onKeyDown={readOnly ? (e) => e.preventDefault() : undefined}
                      fontSize="calc(0.7rem + 0.3vw)"
                    />
                  </Div>
                );
              case "read":
                return (
                  <Font className="w-full" fontWeight="500">
                    {readData}
                  </Font>
                );
              default:
                return null;
            }
          })()}
        </LineInputBox>
      </WrapMobile>
      <WrapMobile>
        <LineInputLabel width={labelWidth} bgColor={labelColor}></LineInputLabel>
        <Font color={noticeRedColor} className="w-[80%] ps-[0.5rem]" fontSize="calc(0.7rem + 0.3vw)">
          {errors}
        </Font>
      </WrapMobile>
    </LineBox>
  );
}
export default InputLine;
